/* MBH Leather: optional $10 personalization, paired cart lines. */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const addonId = 68233109438699;
  const groups = cart => {
    const map = new Map();
    for (const item of cart.items) {
      const pair = item.properties?._mbh_pair;
      if (pair) { if (!map.has(pair)) map.set(pair, []); map.get(pair).push(item); }
    }
    return map;
  };
  // Keep the fee and its product together for quantity edits and removals.
  let cartQueue = Promise.resolve();
  window.fetch = function(input, options) {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    if (!/\/cart\/(change|update)\.js(?:\?|$)/.test(url) || !options?.body || typeof options.body !== 'string') return nativeFetch(input, options);
    let payload; try { payload = JSON.parse(options.body); } catch { return nativeFetch(input, options); }
    const operation = async () => {
      const cartResponse = await nativeFetch(root() + 'cart.js');
      if (!cartResponse.ok) throw new Error('Unable to check personalization quantities. Please try again.');
      const cart = await cartResponse.json();
      const pairs = groups(cart);
      if (!pairs.size) return nativeFetch(input, options);
      const updates = {};
      if (/\/change\.js/.test(url)) {
        const item = payload.line ? cart.items[Number(payload.line) - 1] : cart.items.find(i => i.key === String(payload.id) || String(i.variant_id) === String(payload.id));
        if (!item?.properties?._mbh_pair || payload.properties || payload.selling_plan) return nativeFetch(input, options);
        for (const linked of pairs.get(item.properties._mbh_pair)) updates[linked.key] = Number(payload.quantity);
      } else {
        if (Array.isArray(payload.updates)) cart.items.forEach((item, index) => { if (payload.updates[index] !== undefined) updates[item.key] = Number(payload.updates[index]); });
        else Object.assign(updates, payload.updates || {});
        for (const linked of pairs.values()) {
          const changed = linked.find(i => updates[i.key] !== undefined && Number(updates[i.key]) !== i.quantity) || linked.find(i => updates[i.key] !== undefined);
          if (changed) for (const item of linked) updates[item.key] = Number(updates[changed.key]);
        }
      }
      return nativeFetch(root() + 'cart/update.js', {...options, body: JSON.stringify({...payload, id: undefined, line: undefined, quantity: undefined, updates})});
    };
    const task = cartQueue.then(operation);
    cartQueue = task.catch(() => {});
    return task;
  };
  class MBHPersonalization extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.enabled = this.querySelector('[data-mbh-enable]');
      this.text = this.querySelector('[data-mbh-text]');
      this.fields = this.querySelector('[data-mbh-fields]');
      this.addEventListener('input', () => this.refresh());
      this.addEventListener('change', () => this.refresh());
      this.refresh();
    }
    refresh() {
      const on = this.enabled.checked;
      this.fields.hidden = !on; this.text.disabled = !on;
      this.querySelector('[data-mbh-count]').textContent = this.text.value.length + '/30';
      const font = this.querySelector('input[type=radio]:checked').value;
      const preview = this.querySelector('[data-mbh-preview]');
      preview.textContent = this.text.value || 'Your name';
      preview.className = font === 'Montserrat' ? 'mbh-sans' : font === 'Times New Roman' ? 'mbh-serif' : 'mbh-script';
      this.error('');
    }
    error(message) { const el = this.querySelector('[data-mbh-error]'); el.textContent = message; el.hidden = !message; }
    validate() {
      const value = this.text.value.trim();
      if (!value || value.length > 30 || value.split(/\s+/).length > 5) {
        this.error('Enter a name, initials or message of up to 30 characters and 5 words.'); this.text.focus(); return false;
      }
      return true;
    }
  }
  customElements.define('mbh-personalization', MBHPersonalization);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.js-product-form')) return;
    const component = form.querySelector('mbh-personalization');
    if (!component) return;
    // The old premium variant is never charged alongside the new add-on.
    if (component.dataset.legacy === 'true') form.querySelector('[name=id]').value = component.dataset.base;
    if (!component.enabled.checked) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (component.busy || !component.validate() || !form.reportValidity()) return;
    const productForm = form.closest('product-form');
    if (productForm?.validate && !productForm.validate()) return;
    component.busy = true;
    const button = form.querySelector('[name=add]');
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    try {
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      if (!id || !Number.isInteger(quantity) || quantity < 1) throw new Error('Choose an available product and quantity.');
      const pair = crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
      const properties = {};
      for (const [key, value] of data) { const match = key.match(/^properties\[(.+)\]$/); if (match) properties[match[1]] = value; }
      const text = component.text.value.trim();
      const font = component.querySelector('input[type=radio]:checked').value;
      Object.assign(properties, {'Personalization': text, 'Font': font, '_mbh_pair': pair, '_mbh_role': 'product'});
      const item = {id, quantity, properties};
      if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
      const response = await nativeFetch(root() + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[item,{id:addonId,quantity,properties:{'For':component.dataset.productTitle,'Personalization':text,'Font':font,'_mbh_pair':pair,'_mbh_role':'fee'}}]})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add personalization. Please try again.');
      window.location.assign(root() + 'cart');
    } catch (error) { component.error(error.message || 'Unable to add this item. Please try again.'); }
    finally { component.busy = false; if(button) { button.disabled = false; button.classList.remove('is-loading'); } }
  }, true);
})();
